import { replaceRouteParams } from '../../helpers/url'

import { ROUTE_PARAMS, ROUTES } from '../../constants/routes'
import { PROVIDER_TO_PLATFORMS } from '../../constants/selectLists/platformList'

export const createCampaignSummaryPageLink = (item, createItemLinkExtraParams = {}) => {
  const { id, provider, ad_account_id: adAccountId } = item
  return replaceRouteParams(ROUTES.campaignsSummary, {
    [ROUTE_PARAMS.campaignId]: id,
    [ROUTE_PARAMS.platform]: PROVIDER_TO_PLATFORMS[provider],
    [ROUTE_PARAMS.adAccount]: adAccountId,
    ...createItemLinkExtraParams
  })
}
